import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isInboxLoaded: false,
    inboxDetailList: [],
    messageLogList: [],
    isAppointmentLoaded: false,
    appointmentDetailList: [],
    maxMessageLogId:0
}

const eventsSlice = createSlice({
    name: 'inboxlists',
    initialState,
    extraReducers: (builder) => {

        //inbox page 

        builder.addCase(actions.getInboxList.pending, (state) => {
            state.isInboxLoaded = false;
        })
        builder.addCase(actions.getInboxList.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.inboxDetailList = action.payload.data;
            } else {
                state.inboxDetailList = [];
            }
            state.isInboxLoaded = true;
        })
        builder.addCase(actions.getInboxList.rejected, (state) => {
            state.isInboxLoaded = false;
        });

        // GetAllMessageLog
        builder.addCase(actions.getMessageLogHistory.pending, (state) => {
            state.isInboxLoaded = false;
        })
        builder.addCase(actions.getMessageLogHistory.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.messageLogList = action.payload.data;
                const messageLogIds = action.payload.data.messageLogs.map(x => x.id);
                state.maxMessageLogId = Math.max(...messageLogIds);
            } else {
                state.messageLogList = [];
                
            }
            state.isInboxLoaded = true;
        })
        builder.addCase(actions.getMessageLogHistory.rejected, (state) => {
            state.isInboxLoaded = false;
        });

        //Refresh GetAllMessageLog
        builder.addCase(actions.getRefreshMessageLogHistory.pending, (state) => {
            state.isInboxLoaded = true;
        })
        builder.addCase(actions.getRefreshMessageLogHistory.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data.messageLogs;
                //state.messageLogList.messageLogs.concat(returnObj);
                if (state.messageLogList.messageLogs) {
                    state.messageLogList.messageLogs = state.messageLogList.messageLogs.concat(returnObj);
                } else {
                    state.messageLogList.messageLogs = returnObj;
                }
                const messageLogIds = action.payload.data.messageLogs.map(x => x.id);
                state.maxMessageLogId = Math.max(...messageLogIds);             
            }
            state.isInboxLoaded = false;
        })
        builder.addCase(actions.getRefreshMessageLogHistory.rejected, (state) => {
            state.isInboxLoaded = false;
        });

        //Update GetAllMessageLog
        builder.addCase(actions.addInboxComposeMessageLog.pending, (state) => {
            state.isInboxLoaded = true;
        })
        builder.addCase(actions.addInboxComposeMessageLog.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data;
                state.messageLogList.messageLogs.push(returnObj);
            }
            state.isInboxLoaded = false;
        })
        builder.addCase(actions.addInboxComposeMessageLog.rejected, (state) => {
            state.isInboxLoaded = false;
        });


        //For Appointment page
        builder.addCase(actions.getAppointmentListGroupByLocation.pending, (state) => {
            state.isAppointmentLoaded = false;
        })
        builder.addCase(actions.getAppointmentListGroupByLocation.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.appointmentDetailList = action.payload.data;
            } else {
                state.appointmentDetailList = [];
            }
            state.isAppointmentLoaded = true;
        })
        builder.addCase(actions.getAppointmentListGroupByLocation.rejected, (state, action) => {
            console.error('Error fetching appointment data:', action.error.message);
            state.isAppointmentLoaded = false;
        });
      
    }
});

export default eventsSlice.reducer;